import { getStore } from '../../store/createStore';

const functionList = [];
var scrollTop = 0;
var isIphone = false;

const addBackHandler = func => {
	if (typeof func === 'function') {
		functionList.push(func);
	}
};

const removeBackHandler = func => {
	if (typeof func !== 'function') {
		return;
	}

	const funcIndex = functionList.indexOf(func);
	if (funcIndex != -1) {
		functionList.splice(funcIndex, 1);
	}
};

const initializeHistoryHandler = history => {
	if (typeof window == 'undefined') {
		return;
	}
	const store = getStore();
	isIphone = store.getState() && store.getState().deviceData.isIphone;
	const restoreScroll = () => {
		if (isIphone) {
			document.body.scrollTop = scrollTop;
		} else {
			document.documentElement.scrollTop = scrollTop;
		}
		// window.removeEventListener('scroll', restoreScroll);
	};

	window.addEventListener('popstate', e => {
		if (isIphone) {
			scrollTop = document.body.scrollTop;
		} else {
			scrollTop = document.documentElement.scrollTop;
		}
		// window.addEventListener('scroll', restoreScroll);
		functionList.forEach(func => {
			func(e);
		});
	});

	//removing modal
	if (/\w-modal$/.test(history.location.state)) {
		history.goBack();
	}
};

const goBackToState = ({ dest, history, cb = () => {} }) => {
	const backFunc = () => {
		if (history.location.state == dest) {
			removeBackHandler(backFunc);
			cb();
		} else if (history.location.state) {
			history.go(-1);
		}
	};

	addBackHandler(backFunc);
	history.go(-1);
};

const pushState = (history, state) => {
	history.push(history.location.pathname + history.location.search, state);
};

export {
	initializeHistoryHandler,
	addBackHandler,
	removeBackHandler,
	goBackToState,
	pushState
};
